import React from 'react';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import { Video, Wand2 } from 'lucide-react';

const VideoResourcesHeader: React.FC = () => {
  const handleGenerateVideo = () => {
    // Scroll to the top of the page to focus on the sidebar
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <DashboardHeader
      title="Public Video Generator"
      icon={<Video size={24} />}
      description="Create, browse, and discover AI-generated videos"
      primaryAction={{
        label: "New Video",
        icon: Wand2,
        onClick: handleGenerateVideo,
        variant: "primary"
      }}
    />
  );
};

export default VideoResourcesHeader; 